export const Identifier = {
    mounted(element: unknown, bindings: any) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        // eslint-disable-next-line no-param-reassign
        element.dataset.cy = bindings.value;

        // Also set data-pw for Playwright tests
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        // eslint-disable-next-line no-param-reassign
        element.dataset.pw = bindings.value;
    },
};

export default Identifier;
